<div class="call-flow">
  @if (loading$ | async) {
    <div class="loading-spinner">
      <i [nimbusIcon]="icons.SPINNER" [iconWeight]="IconWeight.Regular"></i>
    </div>
  } @else if (initialCaller$ | async; as initialCaller) {
    @let isOutboundCall = isOutboundCall$ | async;
    <div class="participants">
      <ul>
        <li class="active">
          <div class="participant">
            <div class="text">
              <span class="name">
                @if (isOutboundCall) {
                  <i [nimbusIcon]="icons.ARROW_LEFT"></i>
                }
                @if (isOutboundCall) {
                  <i [nimbusIcon]="icons.USERS"></i>
                }
                @if (!isOutboundCall) {
                  <i [nimbusIcon]="icons.OPERATOR_CUSTOMER"></i>
                }
                <span>
                  <nimbus-tooltip [text]="initialCaller.serviceName || (TranslationKeys.GeneralAnonymous | translate)"> </nimbus-tooltip>
                  {{ initialCaller.serviceName || (TranslationKeys.GeneralAnonymous | translate) }}
                </span>
              </span>
              <br />
              <span class="info">{{ initialCaller.servicePstnNumber }}</span>
            </div>
          </div>
        </li>

        @if (transferors$ | async; as transferors) {
          @for (transferor of transferors; track $index) {
            <li class="action-item">
              <div class="between">
                {{ getTransferorAction(transferor) }}
              </div>
            </li>
            <li class="empty">
              <div class="participant">
                <div class="text">
                  <span class="name">
                    <i class="transferor-icon" [nimbusIcon]="icons.USERS"></i>
                    {{ transferor.serviceName }}
                  </span>
                  <br />
                  <span class="info">{{ transferor.servicePstnNumber }}</span>
                </div>
              </div>
            </li>
          }
        }

        @if (connectedService$ | async; as connectedService) {
          <li class="action-item">
            <div class="between">
              {{ getTransferorAction(connectedService) }}
            </div>
          </li>
          <li class="participant">
            <div class="text">
              <span class="name">
                @if (isOutboundCall) {
                  <i [nimbusIcon]="icons.OPERATOR_CUSTOMER"></i>
                }
                @if (!isOutboundCall) {
                  <i [nimbusIcon]="icons.USERS"></i>
                }
                <span>
                  <nimbus-tooltip [text]="connectedService.serviceName"> </nimbus-tooltip>
                  {{ connectedService.serviceName }}
                </span>
              </span>
              <br />
              <span class="info">{{ connectedService.servicePstnNumber }}</span>
            </div>
          </li>
        }
      </ul>
    </div>
  }
</div>
